import { getURL, setHeaders } from "../../../Apis/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { openModal } from "../../Errors/Slices/errorSlice";

const logError = createAsyncThunk("error/logerror", async (error, thunkAPI) => {
  try {
    console.log(error, "this is the error inside of the logError function");
    const requestBody = { notetext: "" };
    const userId = 1;
    const Axios = getURL();
    const response = await Axios.post(
      `logins/${userId}/objectnotes`,
      requestBody
    );
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data.errormessage);
  }
});

export { logError };
